import React from "react";
import { VariantBase } from "scmp-sdk/components/newsletter/newsletter-widget/variants/component";

import { Container, theme } from "./styles";

export { config as homepageV2ThemeConfig } from "./config";
export {
  HomepageV2ThemeFindOutMoreDisplay,
  HomepageV2ThemeSignUpButtonDisplay,
} from "./homepage-v2-theme-button-display";

export const HomepageV2Theme: React.FunctionComponent<{ children?: React.ReactNode }> = ({
  children,
  ...props
}) => (
  <VariantBase theme={theme}>
    <Container {...props}>{children}</Container>
  </VariantBase>
);

HomepageV2Theme.displayName = "HomepageV2Theme";
